<template>
  <div class="">
    <DataTable :value="items" sortField="score" :sortOrder="-1" tableStyle="min-width: 50rem">
      <Column field="name" :header="nameTitle" sortable class="" style="width: 70%">
        <template #body="slotProps">
          <div class="flex items-center font-semibold">
            {{ slotProps.data[nameProp] }}
          </div>
          <div class="text-sm mt-1">
            {{ slotProps.data?.explanation }}
          </div>
        </template>
      </Column>
      <Column field="score" header="Score" sortable style="width: 15%">
        <template #body="slotProps">
          <div class="">
            <div class="relative">
              <div class="w-10 font-semibold">
                <div>{{ slotProps.data?.score }}</div>
              </div>
            </div>
            <equalizer-value class="mt-1 w-full" :value="slotProps.data?.score" :max="10" :height="10" :reverse="true" :color="scoreColor"></equalizer-value>
          </div>
        </template>
      </Column>
      <Column v-if="trendProp" header="Trend" style="width: 15%">
        <template #body="slotProps">
          <DbTrendValue class="w-full h-9" :data="slotProps.data[trendProp]" :reverse="reverse"></DbTrendValue>
        </template>
      </Column>
      <!--<Column field="diff" header="Improvement" sortable style="width: 25%">
        <template #body="slotProps">
          <div class="flex">
            <div class="grow flex items-center mr-1">
              <equalizer-value class="w-full" :negative="true" :value="slotProps.data?.diff < 0 ? Math.abs(slotProps.data?.diff) : 0" :max="10" :height="20" :reverse="true" :color="negImprovementColor"></equalizer-value>
            </div>
            <div class="grow-0 flex w-10 h-8 items-center justify-center bg-slate-100 rounded-md font-semibold">
              <div>{{ slotProps.data?.diff }}</div>
            </div>
            <div class="grow flex items-center ml-1">
              <equalizer-value class="w-full" :value="slotProps.data?.diff > 0 ? slotProps.data?.diff : 0" :max="10" :height="20" :reverse="true" :color="posImprovementColor"></equalizer-value>
            </div>
          </div>
        </template>
      </Column>-->
    </DataTable>
  </div>
</template>

<script setup>
  import EqualizerValue from '@/components/Charts/EqualizerValue.vue';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import DbSparkLine from '@/components/Charts/DbSparkLine.vue';
  import DbTrendValue from '@/components/Charts/DbTrendValue.vue';
  import dayjs from 'dayjs';

  const props = defineProps({
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    nameProp: {
      type: String,
      default: 'name',
    },
    trendProp: {
      type: String,
      default: null,
    },
    nameTitle: {
      type: String,
      default: 'Name',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    improvement: {
      type: Boolean,
      default: true,
    },
    scoreColor: {
      type: String,
      default: '#065f46',
    },
    negImprovementColor: {
      type: String,
      default: '#991b1b',
    },
    posImprovementColor: {
      type: String,
      default: '#065f46',
    },
  });

  function getImprovementIcon(val) {
    return val >= 0 ? 'arrow-up-bold-circle-outline' : 'arrow-down-bold-circle-outline';
  }

  function getImprovementIconClass(val) {
    if (props.reverse) {
      return val >= 0 ? 'text-orange-600/70' : 'text-teal-600/70';
    } else {
      return val >= 0 ? 'text-teal-600/70' : 'text-orange-600/70';
    }
  }

  // color="#991b1b"
</script>
